export default {
      id: "document-blank-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#document-blank",
      toString: function () {
        return this.url;
      }
    }